import type { CarSchemeQuoteResult } from './SchemeQuoteResult'
import { JsonObject, JsonProperty } from 'json2typescript'
import PaymentTypeEnumConverter from '@/converters/PaymentTypeEnumConverter'
import { PaymentTypeEnum } from '../enums/DLDCommonValuesEnum'
import { DefinedListDetail } from './DefinedList'
import { ProposerDriver } from './Driver'
import QuoteDetails from './QuoteDetails'

@JsonObject('CarQuoteDetails')
export class CarQuoteDetails extends QuoteDetails<CarSchemeQuoteResult> {
  @JsonProperty('voluntaryExcess', DefinedListDetail)
  voluntaryExcess: DefinedListDetail = new DefinedListDetail()

  @JsonProperty('noClaimsBonus', Number)
  noClaimsBonus = 0

  @JsonProperty('policyDuration', DefinedListDetail)
  policyDuration: DefinedListDetail = new DefinedListDetail()

  @JsonProperty('registeredKeeper', DefinedListDetail)
  registeredKeeper: DefinedListDetail = new DefinedListDetail()

  @JsonProperty('coverType', DefinedListDetail)
  coverType: DefinedListDetail = new DefinedListDetail()

  @JsonProperty('mainDriver', ProposerDriver)
  mainDriver: ProposerDriver = new ProposerDriver()

  @JsonProperty('registrationNumber', String)
  registrationNumber = ''

  @JsonProperty('coverTerm', DefinedListDetail)
  coverTerm: DefinedListDetail = new DefinedListDetail()
}

@JsonObject('CarRenewalQuoteDetails')
export class CarRenewalQuoteDetails extends CarQuoteDetails {
  @JsonProperty('initialPaymentMethod', PaymentTypeEnumConverter)
  initialPaymentMethod: PaymentTypeEnum = PaymentTypeEnum.CardPayment

  @JsonProperty('previousPolicyScheme', String)
  previousPolicyScheme = ''
}

@JsonObject('CarMTAQuoteDetails')
export class CarMTAQuoteDetails extends CarQuoteDetails {
  @JsonProperty('initialPaymentMethod', PaymentTypeEnumConverter)
  initialPaymentMethod: PaymentTypeEnum = PaymentTypeEnum.CardPayment

  @JsonProperty('hasUpgradableVAP', Boolean)
  hasUpgradableVAP = true

  @JsonProperty('hasClaims', Boolean)
  hasClaims = false

  @JsonProperty('message', String)
  message = ''
}
